<template>
<BaseTemplate>
  <div class="base">
    <Title :jpn="t('登録情報')"></Title>
    <div class="input-area">
      <SubTitle class="subtitle">{{ t('名前') }}</SubTitle>
      <div class="address_area flex">
        <div class="last-name-container">
          <LabelItem
            class="label-item referralCode"
            :text="lastName"
          />
        </div>
        <div class="first-name-container">
          <LabelItem
            class="label-item referralCode"
            :text="middleName"
          />
        </div>
        <div class="first-name-container">
          <LabelItem
            class="label-item referralCode"
            :text="firstName"
          />
        </div>
      </div>
      <div class="address_area">
        <LabelItem
          class="label-item"
          :label="t('国')"
          :text="countryName"
        />
        <LabelInput
          class="label-input"
          :labelText="t('郵便番号')"
        >
          <LabelItem
            class="label-item referralCode"
            :text="zipCode"
          />
        </LabelInput>
        <LabelInput v-if="countryId == '84'" class="label-input" :labelText="t('都道府県')">
          <LabelItem
            class="label-item referralCode"
            :text="prefName"
          />
        </LabelInput>
        <LabelInput v-if="countryId != '84'" class="label-input" :labelText="t('州')">
          <LabelItem
            class="label-item referralCode"
            :text="province"
          />
        </LabelInput>
        <LabelInput class="label-input" :labelText="t('市区町村')">
          <LabelItem
            class="label-item referralCode"
            :text="shiku"
          />
        </LabelInput>
        <LabelInput class="label-input" :labelText="t('番地')">
          <LabelItem
            class="label-item referralCode"
            :text="address"
          />
        </LabelInput>
        <LabelInput
          class="label-input"
          :labelText="t('建物名')"
        >
          <LabelItem
            class="label-item referralCode"
            :text="building"
          />
        </LabelInput>
      </div>
      <div class="address_area">
        <LabelInput
          class="label-input"
          :labelText="t('言語')"
        >
        <SelectBox
          :memberChange="true"
          :options="formatLanguageList"
          :selectedOption="languageId"
          placeholder="Language"
          :value="languageId"
          @handleSelectChange="changeLanguageId"
        />
        <ErrorMessage
          v-if="errorMessageLanguageId"
          class="error-message"
          :message="errorMessageLanguageId"
        />
        <div class="button_area">
          <BuyButton
            :isArrow="false"
            class="label-input nomt sms_button"
            :text="t('変更する')"
            @handleSquareBtnClick="languageChange"
          />
        </div>
        </LabelInput>
      </div>
      <SubTitle id="tel" class="subtitle">{{ t('電話番号') }}</SubTitle>
      <div class="address_area">
        <TextBox
          class="text-box tel"
          inputType="text"
          :value="tel"
          :readonly="end_sms == 1"
          placeholder="01234567890"
          @handleTextInput="inputTel"
        />
        <ErrorMessage
          v-if="errorMessageTel"
          class="error-message"
          :message="errorMessageTel"
        />
        <div class="button_area">
          <BuyButton
            :isArrow="false"
            class="label-input nomt sms_button"
            :text="t('SMS認証')"
            v-if="end_sms == 0"
            @handleSquareBtnClick="smsPopup"
          />
        </div>
      </div>

      <SubTitle class="subtitle">{{ t('メールアドレス') }}</SubTitle>
      <div class="address_area">
        <LabelItem
          class="label-item"
          :text="mail"
        />
      </div>

      <SubTitle class="subtitle">{{ t('友達紹介コード') }}</SubTitle>
      <div class="address_area">
        <LabelItem
          class="label-item referralCode"
          :text="referral_code"
        />
        <!-- <div class="referral_message" v-if="referral_code != ''">You can introduce up to 10 friends only if you have completed SMS authentication and have made at least one payment on this site. After registration, if your friend completes SMS authentication, both parties will receive 1000P.</div> -->
        <div class="chat_message">{{ t('個人情報を変更希望の際は、チャットにてお問い合わせください') }}</div>
        <!-- <div class="text-red mb-2">
          {{ t('お問い合わせは画面右下のチャットよりお願いいたします。') }}
        </div> -->
        <div class="text-red mb-">
          {{ t('※発送先のご住所は初めて発送依頼いただく際にご登録いただきます') }}
        </div>
      </div>
    </div>

    <div v-if="!countryName" class="contact_message">
      {{ t('初めて配送を選択する際に、この情報を入力できます。') }}
    </div>
    <div class="button_area">
      <SquareButton
        class="label-input nomt square-button"
        :text="t('戻る')"
        @handleSquareBtnClick="goToBack"
      />
    </div>
  </div>
  <AlertSuccess
    ref="alertSuccess"
    :isShow="isShowAlertSuccess"
    :text="t('変更が完了しました')"
    v-click-outside="closeAlertSuccess"
  />
  <AlertSuccess
    ref="alertSMSSuccess"
    :isShow="isShowSMSAlertSuccess"
    :text="t('変更が完了しました')"
    v-click-outside="closeSMSAlertSuccess"
  />
  <SMSPopup
    v-if="showSMSPopup"
    :tel="tel"
    @success="smsSuccess"
    @closePopup="showSMSPopup = false">
  </SMSPopup>
</BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import AlertSuccess from '@/components/atoms/AlertSuccess.vue';
import SMSPopup from '@/components/molecules/SMSPopup.vue';
import LabelItem from '@/components/molecules/LabelItem.vue';
import Title from '@/components/molecules/Title02.vue';
import SubTitle from '@/components/molecules/SubTitle.vue';
import TextBox from '@/components/atoms/TextBox.vue';
import SelectBox from '@/components/atoms/SelectBox.vue';
import SquareButton from '@/components/atoms/SquareButton.vue';
import ErrorMessage from '@/components/atoms/ErrorMessage.vue';
import LabelInput from '@/components/molecules/LabelInput.vue';
import BuyButton from '@/components/atoms/BuyButton.vue';
import t from '@/plugins/i18n';

export default {
  mixins: [t],

  components: {
    BaseTemplate,
    AlertSuccess,
    LabelItem,
    TextBox,
    SMSPopup,
    ErrorMessage,
    LabelInput,
    Title,
    SubTitle,
    SquareButton,
    BuyButton,
    SelectBox,
  },

  data: () => ({
    languageId: null,
    errorMessageCountryId: '',
    errorMessageLanguageId: '',
    lastName: null,
    middleName: null,
    firstName: null,
    tel: null,
    mail: null,
    province: null,
    zipCode: null,
    prefectureId: null,
    country: null,
    prefName: null,
    shiku: null,
    address: null,
    building: null,
    password: null,
    point: null,
    end_sms: 0,
    referral_code: '',
    countryId: null,
    confirmPass: null,
    showSMSPopup: false,
    isShowAlertSuccess: false,
    isShowSMSAlertSuccess: false,
    errorMessageLastName: null,
    errorMessageMiddleName: null,
    errorMessageFirstName: null,
    errorMessageTel: null,
    errorMessageMail: null,
    errorMessageProvince: null,
    errorMessageZipCode: null,
    errorMessagePrefectureId: null,
    errorMessageCountry: null,
    errorMessageShiku: null,
    errorMessageAddress: null,
    errorMessageBuilding: null,
  }),

  computed: {
    ...mapGetters({
      prefectureList: 'prefecture/prefectureList',
      languageList: 'language/languageList',
      currentUser: 'user/currentUser',
      currentUserDetail: 'user/currentUserDetail',
      currentAddress: 'zipCode/currentAddress',
      changeUserInformationResult: 'user/changeUserInformationResult',
      logOutUserResult: 'user/logOutUserResult',
      countryList: 'country/countryList',
      changeLanguageResult: 'user/changeLanguageResult',
    }),
    formatLanguageList() {
      if (this.languageList) {
        return this.languageList.slice(1);
      }
      return [];
    },
    countryName() {
      if (this.countryList) {
        if (this.countryId && this.countryId !== '0') {
          return this.countryList.find(
            (country) => country.id === this.countryId,
          ).name;
        }
      }
      return null;
    },
  },

  watch: {
    currentAddress(newVal) {
      if (newVal) {
        if (newVal.state === 200) {
          const { result } = newVal;
          this.selectPrefectureId(result[0].prefcode);
          this.inputShiku(`${result[0].address2}${result[0].address3}`);
        }
      }
    },
    changeLanguageResult(newVal) {
      if (newVal.state === 200) {
        this.isShowAlertSuccess = true;
        setTimeout(() => {
          window.location.reload();
        }, 100);
      } else {
        const { language_id: languageId } = newVal.errors;
        this.errorMessageLanguageId = languageId ? languageId[0] : null;
      }
    },
    currentUserDetail(newResult) {
      this.$nextTick(() => {
        this.lastName = newResult.lastName;
        this.middleName = newResult.middleName;
        this.firstName = newResult.firstName;
        this.tel = newResult.tel;
        this.mail = newResult.mail;
        this.zipCode = newResult.zipcode;
        this.province = newResult.province;
        // this.prefectureId = newResult.pref_id;
        this.country = newResult.country;
        this.prefName = newResult.pref_name;
        this.shiku = newResult.shiku;
        this.address = newResult.address;
        this.building = newResult.building;
        this.point = newResult.availablePoint;
        this.end_sms = newResult.end_sms;
        this.referral_code = newResult.referral_code;
        this.countryId = newResult.country_id;
        // MEMO: 都道府県リストが更新されないため、レンダリング完了を待ち、さらに少し時間差をつける。（100に根拠はないが、リロードして動作を確認）
        setTimeout(() => {
          this.prefectureId = newResult.pref_id;
          this.languageId = newResult.language_id;
        }, 100);
        // mounted時にスクロールすると、スクロールが効かないため、ここでスクロールする
        this.$nextTick(() => {
          const url = window.location.href;
          if (url.includes('#tel')) {
            const el = document.getElementById('tel');
            if (el) {
              el.scrollIntoView({ behavior: 'smooth' });
            }
          }
        });
      });
    },
    changeUserInformationResult(newVal) {
      if (newVal) {
        if (newVal.state === 200) {
          this.$store.dispatch('user/clearChangeUserInformationResult');
          this.isShowAlertSuccess = true;
        } else {
          const {
            lastName, firstName, middleName, tel, mail, zipcode,
            province, pref_id: prefId, shiku, address, building,
          } = newVal.errors;
          this.errorMessageLastName = lastName ? lastName[0] : null;
          this.errorMessageMiddleName = middleName ? middleName[0] : null;
          this.errorMessageFirstName = firstName ? firstName[0] : null;
          this.errorMessageProvince = province ? province[0] : null;
          this.errorMessageTel = tel ? tel[0] : null;
          this.errorMessageMail = mail ? mail[0] : null;
          this.errorMessageZipCode = zipcode ? zipcode[0] : null;
          this.errorMessagePrefectureId = prefId ? prefId[0] : null;
          this.errorMessageShiku = shiku ? shiku[0] : null;
          this.errorMessageAddress = address ? address[0] : null;
          this.errorMessageBuilding = building ? building[0] : null;
        }
      }
    },
  },

  created() {
    this.$store.dispatch('prefecture/setPrefectureList');
    this.$store.dispatch('user/setCurrentUserDetail');
    this.$store.dispatch('country/setCountryList');
  },

  methods: {
    inputLastName(lastName) {
      this.lastName = lastName;
    },
    inputFirstName(firstName) {
      this.firstName = firstName;
    },
    inputMiddleName(name) {
      this.middleName = name;
    },
    inputTel(tel) {
      this.tel = tel;
    },
    inputMail(mail) {
      this.mail = mail;
    },
    inputZipCode(zipCode) {
      this.zipCode = zipCode;
    },
    inputCountry(country) {
      this.country = country;
    },
    selectPrefectureId(prefectureId) {
      this.prefectureId = prefectureId;
    },
    inputShiku(shiku) {
      this.shiku = shiku;
    },
    inputAddress(address) {
      this.address = address;
    },
    inputBuilding(building) {
      this.building = building;
    },
    changeZipCode() {
      if (this.i18n_mode === 'jp') {
        const zipCodeLength = 7;
        if (String(this.zipCode).length === zipCodeLength) {
          const postParams = {
            zipcode: this.zipCode,
          };
          this.$store.dispatch('zipCode/setCurrentAddress', { postParams });
        }
      }
    },
    smsPopup() {
      if (window.confirm(this.t('SMSコードを送信しますか？'))) {
        this.showSMSPopup = true;
      }
    },
    goToBack() {
      this.$router.push('/');
    },
    goToChangePassword() {
      this.$router.push('/change-password');
    },
    upadateUserInfo() {
      if (this.i18n_mode !== 'jp') {
        this.prefectureId = 99;
      }
      const postParams = {
        // lastName: this.lastName,
        // middleName: this.middleName,
        // firstName: this.firstName,
        tel: this.tel,
        // mail: this.mail,
        // zipcode: this.zipCode,
        // pref_id: this.prefectureId,
        // country: this.country,
        // shiku: this.shiku,
        // address: this.address,
        // building: this.building,
      };
      this.$store.dispatch('user/changeUserInformation', { postParams });
    },
    closeAlertSuccess() {
      this.isShowAlertSuccess = false;
    },
    closeSMSAlertSuccess() {
      this.isShowSMSAlertSuccess = false;
    },
    languageChange() {
      if (!this.languageId) {
        this.errorMessageLanguageId = this.t('言語を選択してください');
        return;
      }
      const postParams = {
        language_id: this.languageId,
      };
      this.$store.dispatch('user/changeLanguage', { postParams });
    },
    smsSuccess() {
      this.showSMSPopup = false;
      this.$store.dispatch('user/setCurrentUserDetail');
      this.isShowSMSAlertSuccess = true;
    },
    goContactUs() {
      window.open('https://minny-online-store.iranoan.com/contacts?service=1', '_blank');
    },
    changeLanguageId(languageId) {
      this.languageId = languageId;
    },
  },
};
</script>

<style lang="scss" scoped>
.base {
  padding-top: 30px;
  padding-bottom: 50px;
  max-width: 600px;
  margin: auto;
  .input-area {
    margin: 0;
    padding: 0 10px;
    .address_area {
      padding: 0;
      margin: 10px 0 10px 0;
      .row {
        margin: 5px 0;
      }
      .label-input {
        margin-top: 10px;
      }
      // .tel{
      //   margin-top: 10px;
      // }
    }
    .flex {
      display: flex;
      width: 100%;
      .last-name-container{
        flex: 1 1 150px;
        min-width: 0;
      }
      .first-name-container{
        flex: 1 1 150px;
        min-width: 0;
        margin-left: 15px;
      }
    }
    .announce-area {
      display: flex;
      align-items: center;
      .announce {
        color: $black;
        margin-left: 10px;
        font-size: 14px;
        width: 300px;
      }
    }
  }
  .subtitle{
    font-size: 15px;
    margin-top: 10px;
  }
  .button_area {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .square-button {
      max-width: 200px;
      width: 100%;
      &:nth-child(2) {
        margin-top: 10px;
      }
    }
    .sms_button{
      min-width: 200px;
      font-size:medium;
      padding: 10px;
      &:hover {
        opacity: 0.7;

      }
    }
    .contact {
      font-size:medium;
      padding: 10px;
      &:hover {
        opacity: 0.7;
      }
    }
  }
  .referralCode {
    font-size: 24px;
  }
  .referral_message {
    color: $black;
  }
  .contact_message {
    margin: 10px auto;
    color: $mainColor;
    font-size: 20px;
    text-align: center;
  }
  .chat_message {
    margin: 10px auto;
    color: $mainColor;
    text-align: center;
    font-weight: 700;
  }
}
.text-red {
  margin: 10px auto;
  color: red;
  text-align: center;
}
@media screen and (max-width: $tabletWidth) {
  .base {
    .input-area {
      margin: 10px 0;
    }
    .contact_message {
      font-size: 16px;
    }
  }
}
</style>
